<template>
	<div class="ventas-page">

		<div class="d-flex justify-content-between align-items-center mb-3">
			<div>
				<h1 class="mb-2">Shipping Options</h1>
				<p class="text-muted">{{ rows.length }} {{ rows.length === 1 ? 'option' : 'options' }}</p>
			</div>
			<div class="d-flex gap-3">
				<button class="btn btn-success" @click="openCreateModal">
					<i class="fa fa-plus"></i> Add Option
				</button>
			</div>
		</div>

		<div class="ventas-card p-0">
			<div class="card-body p-0">
				<div class="table-responsive">
					<table class="table ventas-table mb-0">
						<thead>
							<tr>
								<th>Name</th>
								<th>Delivery Time</th>
								<th>Price</th>
								<th>Description</th>
								<th class="text-center" style="width: 120px;">Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="row in rows" :key="row.id">
								<td class="font-weight-medium">{{ row.name }}</td>
								<td class="text-muted">{{ row.delivery_time || '—' }}</td>
								<td>${{ Intl.NumberFormat('en-US').format(row.price) }}</td>
								<td class="text-muted">
									<span class="desc-preview">{{ row.description || '—' }}</span>
								</td>
								<td class="text-center">
									<button class="btn btn-sm btn-outline-secondary border-0" @click="openEditModal(row)">
										<i class="fa fa-edit"></i>
									</button>
									<button class="btn btn-sm btn-outline-danger border-0" @click="deleteRow(row.id)">
										<i class="fa fa-trash"></i>
									</button>
								</td>
							</tr>
							<tr v-if="rows.length === 0">
								<td colspan="5" class="text-center py-4">
									<div class="text-muted">
										<i class="fa fa-truck fa-2x mb-2"></i>
										<p>No shipping options found</p>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>

		<!-- Modal Add / Edit Shipping -->
		<div class="modal fade" id="shippingModal" tabindex="-1">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">{{ form.id ? 'Edit Option' : 'Add Option' }}</h5>
						<button type="button" class="btn btn-xs" @click="closeModal">
							<i class="fa fa-times"></i>
						</button>
					</div>
					<div class="modal-body">
						<form id="shippingForm" @submit.prevent="saveRow">
							<div class="form-group mb-3">
								<label class="control-label">Name *</label>
								<input
									type="text"
									class="form-control"
									v-model="form.name"
									placeholder="e.g. Standard Shipping"
									required
								>
							</div>
							<div class="form-group mb-3">
								<label class="control-label">Delivery Time</label>
								<input
									type="text"
									class="form-control"
									v-model="form.delivery_time"
									placeholder="e.g. 5-7 Business Days"
								>
							</div>
							<div class="form-group mb-3">
								<label class="control-label">Price</label>
								<currency-input
									class="form-control"
									v-model="form.price"
									placeholder="e.g. Free over $75 / $6.99 below"
								></currency-input>
							</div>
							<div class="form-group mb-0">
								<label class="control-label">Description</label>
								<textarea
									class="form-control"
									v-model="form.description"
									rows="4"
									placeholder="Describe this shipping option..."
								></textarea>
							</div>
						</form>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-success" @click="saveRow">
							<i class="fa fa-save"></i> Save
						</button>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
export default {
	data() {
		return {
			rows: [],
			form: {
				id: null,
				name: '',
				delivery_time: '',
				price: '',
				description: ''
			}
		}
	},
	methods: {
		loadRows() {
			this.$root.isLoading = true
			axios.get(tools.url('/api/admin/' + this.$route.meta.path)).then((response) => {
				this.rows = response.data
				this.$root.isLoading = false
			}).catch((error) => {
				this.$root.handleErrors(error)
				this.$root.isLoading = false
			})
		},
		resetForm() {
			this.form = {
				id: null,
				name: '',
				delivery_time: '',
				price: '',
				description: ''
			}
		},
		closeModal() {
			$('#shippingModal').modal('hide')
			this.resetForm()
		},
		openCreateModal() {
			this.resetForm()
			$('#shippingModal').modal('show')
		},
		openEditModal(row) {
			this.form = {
				id: row.id,
				name: row.name || '',
				delivery_time: row.delivery_time || '',
				price: row.price || '',
				description: row.description || ''
			}
			$('#shippingModal').modal('show')
		},
		saveRow() {
			if (!this.form.name) {
				this.$root.showMessage('Name is required', 'error')
				return
			}

			this.$root.isLoading = true
			var data = tools.params(document.getElementById('shippingForm'), this.form)

			var request
			if (this.form.id) {
				request = axios.post(tools.url('/api/admin/' + this.$route.meta.path + '/' + this.form.id), data)
			} else {
				request = axios.post(tools.url('/api/admin/' + this.$route.meta.path), data)
			}

			request.then((response) => {
				this.$root.showMessage(response.data.msg || 'Saved successfully', 'success')
				this.$root.isLoading = false
				$('#shippingModal').modal('hide')
				this.resetForm()
				this.loadRows()
			}).catch((error) => {
				this.$root.isLoading = false
				this.$root.handleErrors(error)
			})
		},
		deleteRow(id) {
			this.$swal({
				title: 'Are you sure you want to delete this shipping option?',
				text: 'You will not be able to revert this!',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes, delete',
				cancelButtonText: 'Cancel',
				customClass: {
					popup: 'custom-toast'
				},
			}).then((result) => {
				if (result.isConfirmed) {
					axios.delete(tools.url('/api/admin/' + this.$route.meta.path + '/' + id))
						.then((response) => {
							this.$root.showMessage(response.data.msg, 'success')
							this.loadRows()
						})
						.catch((error) => {
							this.$root.handleErrors(error)
						})
				}
			})
		}
	},
	mounted() {
		this.loadRows()
	}
}
</script>

<style scoped>
.desc-preview {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
</style>
